import { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import useBillTrackerAlert from './useBillTrackerAlert';

const BillTrackerWidget = ({ legislationId }) => {
  const { isAuthenticated } = useAuth0();
  const { isBillTracked, getBillTrackerAlert, toggleBillTracker } = useBillTrackerAlert();
  const [isLoading, setIsLoading] = useState(false);

  const fetchBillTrackerAlert = useRef(null);
  fetchBillTrackerAlert.current = (source) => {
    if (!isAuthenticated || !legislationId) return;
    getBillTrackerAlert({ source });
  };

  useEffect(() => {
    const source = new AbortController();
    fetchBillTrackerAlert.current(source);
    return () => {
      source.abort('Bill tracker widget cancelled by the user.');
    };
  }, [legislationId]);

  const handleToggle = async () => {
    if (!isAuthenticated || !legislationId || isLoading) return;
    setIsLoading(true);
    const wasTracked = isBillTracked(legislationId);
    await toggleBillTracker({ id: legislationId });
    setIsLoading(false);
    createNotification(
      'success',
      wasTracked
        ? 'You will no longer receive alerts for updates to this Bill'
        : 'You will receive alerts for updates to this Bill'
    );
  };

  return (
    <div className='mb-3 py-3 px-3 box-rounded box-outstanding-reports bg-white'>
      <h3 className='mb-2'>Bill tracker</h3>
      <button
        className='general-button outline-button main-light-text paragraph-p3 rounded-button px-3 py-1 bg-white w-100 d-flex justify-content-between align-items-center'
        disabled={isLoading || !isAuthenticated || !legislationId}
        onClick={handleToggle}
      >
        <span>Get alerts for updates to this Bill</span>
        <span className={`toggle-button-${isBillTracked(legislationId) ? 'active' : 'inactive'}`}>
          <span className='toggle-button'></span>
        </span>
      </button>
    </div>
  );
};

export default BillTrackerWidget;
